(() => {
  const init = () => {
    document.querySelectorAll('[data-family-picker]').forEach((picker) => {
      if (picker.dataset.initialized === 'true') return;
      picker.dataset.initialized = 'true';

      const catalogueNode = picker.querySelector('[data-family-products]');
      const notice = picker.querySelector('[data-family-notice]');
      let familyProducts = [];

      try {
        familyProducts = JSON.parse(catalogueNode.textContent);
      } catch (error) {
        return;
      }

      const getSelectedSize = () => {
        const controls = [...document.querySelectorAll('variant-selects input[data-option-name], variant-selects select[data-option-name], variant-selects input[name^="options["], variant-selects select[name^="options["]')];
        const sizeControl = controls.find((control) => {
          const optionName = control.dataset.optionName || control.name;
          return optionName.toLowerCase().includes('size') && (control.tagName === 'SELECT' || control.checked);
        });
        return sizeControl ? sizeControl.value : null;
      };

      const showUnavailableSize = () => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('family_size_unavailable') !== '1' || !notice) return;
        const previousSize = params.get('previous_size');
        const currentWidth = params.get('family_width');

        if (previousSize && currentWidth) {
          notice.textContent = `Size ${previousSize} is not offered in the ${currentWidth} band. Please choose an available size.`;
          notice.hidden = false;
        }
      };

      picker.addEventListener('click', (event) => {
        const option = event.target.closest('[data-family-product-id]');
        if (!option || option.classList.contains('is-selected')) return;

        event.preventDefault();
        const target = familyProducts.find((item) => String(item.id) === option.dataset.familyProductId);

        if (!target) {
          window.location.assign(option.href);
          return;
        }

        const size = getSelectedSize();
        const matchedVariant = size && target.variants.find((variant) => {
          const values = variant.options || [variant.option1, variant.option2, variant.option3];
          return values.includes(size);
        });

        if (matchedVariant) {
          window.location.assign(`${target.url}?variant=${matchedVariant.id}`);
          return;
        }

        if (size) {
          const params = new URLSearchParams({
            family_size_unavailable: '1',
            previous_size: size,
            family_width: target.width
          });
          window.location.assign(`${target.url}?${params.toString()}`);
          return;
        }

        window.location.assign(target.url);
      });

      showUnavailableSize();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();